import React from 'react';
import { Activity, CheckCircle2, AlertTriangle, AlertOctagon } from 'lucide-react';
import { StatCard, type AttentionLevel } from '../dashboard/StatCard';
import type { HealthBannerSummary } from '@vehix/shared/types/recallSnapshots';

interface Props {
  summary: HealthBannerSummary;
  loading?: boolean;
}

export const SnapshotKPIStrip: React.FC<Props> = ({ summary, loading = false }) => {
  const warningPlusStale = summary.warning + summary.stale;

  const criticalAttention: AttentionLevel = summary.critical > 0 ? 'critical' : undefined;
  const warningAttention: AttentionLevel = warningPlusStale > 0 ? 'warning' : undefined;

  const warningDescription =
    summary.stale > 0 ? `${summary.stale} stale, ${summary.warning} warning` : undefined;
  const criticalDescription =
    summary.failed_runs_last_7d > 0
      ? `${summary.failed_runs_last_7d} failed run${summary.failed_runs_last_7d === 1 ? '' : 's'} in 7d`
      : undefined;

  return (
    <div className='grid grid-cols-2 md:grid-cols-4 gap-3'>
      <StatCard
        title='Total assets (tenant×OEM)'
        value={summary.total_assets}
        icon={Activity}
        loading={loading}
        description='Each (tenant, OEM) is monitored separately'
      />
      <StatCard
        title='Healthy'
        value={summary.healthy}
        icon={CheckCircle2}
        iconColor='text-emerald-600'
        loading={loading}
      />
      <StatCard
        title='Warning + Stale'
        value={warningPlusStale}
        icon={AlertTriangle}
        loading={loading}
        {...(warningAttention !== undefined && { attention: warningAttention })}
        {...(warningDescription !== undefined && { description: warningDescription })}
      />
      <StatCard
        title='Critical'
        value={summary.critical}
        icon={AlertOctagon}
        loading={loading}
        {...(criticalAttention !== undefined && { attention: criticalAttention })}
        {...(criticalDescription !== undefined && { description: criticalDescription })}
      />
    </div>
  );
};

export default SnapshotKPIStrip;
